import {streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class GetSearchUrlAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {fromSearchJSONToUrlVOMapper} deps.mapper
   * @param {GetUrlSearchService} deps.service
   */
  constructor({config, getUrlSearchService}) {
    super({config, getUrlSearchService})

    this._config = config
    this._getUrlSearchService = getUrlSearchService
  }

  @tracer({metric: 'GetSearchUrlAdsUseCase#execute'})
  execute({search, pageName, dealerSlug, listingSectionId}) {
    return this._getUrlSearchService.execute({search, pageName, dealerSlug, listingSectionId}).then(urlVO => {
      return urlVO.toJSON()
    })
  }
}

export default GetSearchUrlAdsUseCase
